import { statuses, type StatusItemType } from './translations'

type ExperimentStockInformationWidgetConfig = {
  headerTitle: {
    subtitle: string
    title: string
  }
  statuses: StatusItemType[]
}

export const useExperimentStockInformationConfig =
  (): ExperimentStockInformationWidgetConfig => {
    const headerTitle = {
      subtitle:
        'Hinweis: Die Lieferoptionen hängen von Ihrem Liefergebiet ab. Sie können diese im Bestellvorgang einsehen und wählen.',
      title: 'Informationen zur Verfügbarkeit',
    }

    return {
      headerTitle,
      statuses,
    }
  }
